module.exports = "/fonts/RistrettoPro-Bold.svg";